var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[(_vm.collection)?_c('SmartCollection',{attrs:{"collection":_vm.collection,"relative-to-container":_vm.relativeToContainer,"min-height":"auto"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }